export default {
  finalize() {

    //console.log( $('.tm-portfolio-menu li a').first().data('portfolio'));
    $('.tm-portfolio-current').css('background-image','url('+ $('.tm-portfolio-menu li a').first().data('portfolio') +')')

setTimeout(function(){
$('.tm-portfolio-current').fadeIn(600);
},600)

    $('.portfolio-menu-item').hover(
      function() {



        let urldata = $(this).data('portfolio');
        
        $('.tm-portfolio-current').clearQueue().fadeOut(200,function(){ 
             //console.log('out- in');
             $('.tm-portfolio-current').css('background-image','url('+ urldata +')').fadeIn(300)
        });    
      },

      function(){
        //console.log('out');

        $('.tm-portfolio-current').fadeOut(200,function(){
          //console.log('outout');
        });

      });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/portfolio.js